import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'juyo-spinner',
    styleUrls: ['./spinner.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="spinner active">
            <span class="material-symbols-outlined" [style.font-size.px]="size()"> progress_activity </span>
        </div>
    `,
})
export class SpinnerComponent {

    public size = input(16);
}
